import { ofType } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PayloadAction } from '@reduxjs/toolkit';
import { VALIDATE_REGEX } from '../../../../reducers/types';
import { setErrorMessage, setLoadingModalFlagAction, validateClaimData } from '../../../../reducers/actions';
import {
    IncrementValidationErrorCounterAction,
    SetClaimNumberFailedRegexAction,
    SetErrorMessageAction,
    SetLoadingModalFlagAction,
    SetZipCodeFailedRegexAction,
    ValidateRegexAction,
    ValidateRegexPayload,
    ValidationAction,
} from '../../../../reducers';
import Constants from '../../../../../env/constants';
import { ErrorReason } from '../../../../../env/constants/errors';
import {
    incrementValidationErrorCounter,
    setClaimNumberFailedRegex,
    setZipCodeFailedRegex,
} from '../../../../reducers/appStateSlice/appStateSlice';

export class RegexError extends Error {
    action: PayloadAction<string>[];

    constructor() {
        super(ErrorReason.BAD_REGEX);
        this.action = [];
    }

    addAction(action: PayloadAction<boolean>): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.action.push(action);
    }
}

export const testClaimDataRegex = (
    claimData: ValidateRegexPayload,
): Observable<ValidationAction | SetLoadingModalFlagAction> => {
    const regexError = new RegexError();
    if (!Constants.claimNumberRegex.test(claimData.claimNumber)) {
        regexError.addAction(setClaimNumberFailedRegex(true));
    }
    if (!Constants.zipCodeRegex.test(claimData.zipCode)) {
        regexError.addAction(setZipCodeFailedRegex(true));
    }
    if (regexError.action.length) throw regexError;

    return of(validateClaimData(claimData), setLoadingModalFlagAction(true));
};

export const validateRegexEpic = (
    action$: Observable<ValidateRegexAction>,
): Observable<
    | SetLoadingModalFlagAction
    | ValidationAction
    | SetErrorMessageAction
    | SetZipCodeFailedRegexAction
    | SetClaimNumberFailedRegexAction
    | IncrementValidationErrorCounterAction
> =>
    action$.pipe(
        ofType(VALIDATE_REGEX),
        mergeMap((action: ValidateRegexAction) =>
            of(action.payload).pipe(
                mergeMap(testClaimDataRegex),
                catchError((error: Error) =>
                    of(
                        setErrorMessage(error.message),
                        incrementValidationErrorCounter(),
                        ...(error as RegexError).action,
                    ),
                ),
            ),
        ),
    );
